import { render, staticRenderFns } from "./BCXPopover.vue?vue&type=template&id=13914ccd&scoped=true"
import script from "./BCXPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXPopover.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXPopover.vue?vue&type=style&index=0&id=13914ccd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13914ccd",
  null
  
)

export default component.exports